<template>
  <v-container fluid>
    <PageHeading
      text="Аудиогиды"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-audioguide-new'
          }"
        >
          <v-icon
            class="mr-2"
            small
          >
            mdi-plus
          </v-icon>
          Создать аудиогид
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridAudioguides ref="grid"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridAudioguides from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageAudioguides',
  components: {
    PageHeading,
    GridAudioguides
  },
  metaInfo () {
    return {
      title: 'Аудиогиды'
    }
  },
  mixins: [gridPageInterface]
}
</script>
